import {
  AnimationTriggerMetadata,
  animate,
  query,
  style,
  transition,
  trigger
} from '@angular/animations';

export const routerAnimation: AnimationTriggerMetadata = trigger('routerAnimation', [
  transition('* <=> *', [
    query(':enter', [style({ opacity: 0 })], { optional: true }),
    query(
      ':leave',
      [
        style({
          display: 'none',
          opacity: 0
        })
      ],
      { optional: true }
    ),
    query(
      ':enter',
      [
        style({ opacity: 0 }),
        animate('.4s ' + '.2s ' + 'cubic-bezier(.20, .6, .20, .1)', style({ opacity: 1 }))
      ],
      { optional: true }
    )
  ])
]);
